var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"news-letter-list"},[_c('data-table',{ref:"table",attrs:{"service":_vm.service,"entity":_vm.entity,"columns":_vm.columns,"disable-permission-checks":true},scopedSlots:_vm._u([{key:"candidates",fn:function(ref){
var row = ref.row;
return [_c('status-badge',{attrs:{"status":row.candidates ? 'active': 'inactive'}})]}},{key:"clients",fn:function(ref){
var row = ref.row;
return [_c('status-badge',{attrs:{"status":row.clients ? 'active': 'inactive'}})]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }